import {
  Box,
  DialogActions,
  Typography,
} from '@mui/material'
import { useTheme } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'
import { CDN_PATH } from 'src/constants/global'
import styles from './BaseDialog.scss'

interface BaseDialogFooterProps {
  isFullScreen?: boolean
  loading?: boolean
}

const BaseDialogFooter = ({
  isFullScreen,
  loading,
}: BaseDialogFooterProps): JSX.Element => {
  const { breakpoints } = useTheme()
  const isSmallViewport = useMediaQuery(breakpoints.down('sm'))

  return (isFullScreen && loading && !isSmallViewport) ? (
    <DialogActions sx={{ padding: '8px' }}>
      <Box className={styles.baseDialogFooterContainer}>
        { loading ? (
          <Box className={styles.baseDialogFooterLoading}>
            <Typography variant="body3" fontWeight="regular" paddingRight="4px" color="primary.main">
              Powered by
            </Typography>
            <img src={`${CDN_PATH}/images/sika-logo-black.svg`} alt="Sika" />
          </Box>
        ) : null }
      </Box>
    </DialogActions>
  ) : <div />
}

export default BaseDialogFooter
